import { Injectable } from '@angular/core';
import { Geolocation, Geoposition, PositionError } from '@ionic-native/geolocation/ngx';
import { NativeGeocoderOptions, NativeGeocoder, NativeGeocoderResult } from '@ionic-native/native-geocoder/ngx';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';


@Injectable({
  providedIn: 'root'
})
export class LocationFinderService {

  // Readable Address
  address: string;

  // Location coordinates
  latitude: number;
  longitude: number;
  accuracy: number;

  apiResponse: any;

  //Geocoder configuration
  geoencoderOptions: NativeGeocoderOptions = {
    useLocale: true,
    maxResults: 5
  };

  constructor(
    private geolocation: Geolocation,
    private locationAccuracy: LocationAccuracy,
    private nativeGeocoder: NativeGeocoder) {
    // console.log("geolocation-servie",geolocation)
    // console.log("nativeGeocoder-servie",nativeGeocoder)
    // console.log("locationAccuracy-servie",locationAccuracy)
    // document.addEventListener('deviceready', () => {
    //   console.log("device is ready now")
    //   console.log("geolocation", geolocation)
    //   console.log("nativeGeocoder", nativeGeocoder)
    //   console.log("locationAccuracy", locationAccuracy)
    // });
  }

  findGeolocationAndAdress(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      console.log("in location finder-init-")
      // use geolocation to get user's device coordinates
      let options: {timeout?: number; maximumAge?: number; enableHighAccuracy: boolean} = { enableHighAccuracy: true };
      if (window?.localStorage.getItem('DeviceOsName').toLowerCase() !== "ios") {
        options = { ...options, timeout: 10000, maximumAge: 100000 }
      }
      this.geolocation.getCurrentPosition(options)
        .then((resp: Geoposition) => {

          this.latitude = resp.coords.latitude;
          this.longitude = resp.coords.longitude;
          this.accuracy = resp.coords.accuracy;

          // console.log("geolocation-resp--from service", resp);
          //geocoder method to fetch address from coordinates passed as arguments
          // using for kenya
          // this.nativeGeocoder.reverseGeocode(-0.023559, 37.906193, this.geoencoderOptions)
          this.nativeGeocoder.reverseGeocode(resp.coords.latitude, resp.coords.longitude, this.geoencoderOptions)
            .then((result: NativeGeocoderResult[]) => {
              // console.log("getGeoencoder-resp-from service", result)
              if (result.length > 0) {
                // console.log("mobile address-", result[0])
                window.localStorage.setItem("MobileLocation", result[0]['countryCode'])
              }
              resolve(true);
            })
            .catch((error: PositionError) => {
              // console.log("getGeoencoder-error--from service", error);
              reject(error);
            });
        }).catch((error: PositionError) => {
          // console.log("geolocation-error--from service", error);
          reject(error);
        });
    });
  }

  askToTurnOnGPS(): Promise<any> {
    return new Promise((resolve, reject) => {
      // console.log("askToTurnOnGPS2-called")
      this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY)
        .then((resp) => {
          // console.log("askToTurnOnGPS2-locationAccuracy.request-resp-", resp)
          // When GPS Turned ON call method to get Accurate location coordinates
          if ((window?.localStorage.getItem('DeviceOsName').toLowerCase() === "ios" && resp == null) || resp['code'] === 0 || resp['code'] === 1) {//code 0 if gps already on //code 1 if gps is getting turn on
            this.findGeolocationAndAdress().then((res) => {
              resolve(res)
            },
              (err) => {
                reject(err)
              });
          }
        },
          (error) => {
            console.log("askToTurnOnGPS2-locationAccuracy.request-error-", error)
            reject(error);
          }
        ).catch((err) => {
          console.log("askToTurnOnGPS2-locationAccuracy.request-catch-", err)
          reject(err);
        });
    });
  }
}


